import {Component, Input, OnInit} from '@angular/core';
import {WidgetDetail} from '../../../../../../../domain/widget/model/widget-detail';
import {Article} from '../../../../../../../domain/publications/model/article';
import {DomainUrlService} from '../../../../../../../application/config/domain-url.service';
import {UserContextService} from '../../../../../../../application/app-context/user-context/user-context.service';
import {AmplitudeService} from '../../../../../../../application/analytics/service/amplitude.service';

@Component({
             selector: 'app-widget-publication-latest-articles',
             templateUrl: './home-dashboard-widget-publication-latest-articles.component.html',
             styleUrls: ['./home-dashboard-widget-publication-latest-articles.component.scss']
           })
export class HomeDashboardWidgetPublicationLatestArticlesComponent implements OnInit {

  readonly TRACK_ACTION_CLICK_LAST_ARTICLE_ITEM = 'Widget_ArticlesLarge_DisplayArticle';

  @Input() widget: WidgetDetail;
  @Input() articles: Array<Article>;

  publicationUrl: string;
  accountId: string;


  constructor(private domainUrlService: DomainUrlService,
              private userContextService: UserContextService,
              private amplitudeService: AmplitudeService) {
  }

  ngOnInit(): void {
    this.publicationUrl = this.domainUrlService.getPublicationUrl();
    this.accountId = this.userContextService.getUserContext().accountId;
  }

  onClickTrackAction() {
    const eventProperties = new Map<string, string>();
    eventProperties.set('Action', 'Widget_ArticlesLarge_DisplayAllArticles');
    this.amplitudeService.trackEventProperties('Widget_ArticlesLarge_DisplayAllArticles', eventProperties);
  }
}
